module.exports = __webpack_public_path__ + "b3e20ed060bd1706367a856dd1b72335.pdf";